// Fallback data providers

export const provideEmptyNotifications = () => {
  return [];
};

export const provideEmptyNotificationCount = () => {
  return { count: 0 };
};

export const provideEmptyUsers = () => {
  return [];
};

export const provideEmptySentNotifications = () => {
  return [];
};